import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

import i18n from 'utils/I18n';
import { detectIsPadOrMobileByScreenWidth } from 'utils/ScreenUtils';
import CustomMarkdown from 'component/base/CustomMarkdown'

class Instruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fold: this.props.instructions?.content?.length > 200,
    };
  }

  render() {
    const isPadOrMobileView = detectIsPadOrMobileByScreenWidth();
    return (
      <Container className="instruction_container">
        <div className={`instruction_sections ${isPadOrMobileView ? "title-small" : "headline"}`}>
          <CustomMarkdown>{this.props.instructions.title}</CustomMarkdown>
        </div>
        <div
          className={`instruction_step ${
            this.props.renderMask & this.state.fold
              ? 'instruction_step_masked'
              : ''
          } ${
            isPadOrMobileView ? "body-1" : "field-text"
          }`}
        >
          <CustomMarkdown>{this.props.instructions.content}</CustomMarkdown>
        </div>
        {this.props.renderMask & this.state.fold ? (
          <>
            <div class="mask" />
            <span
              className={`read-more ${isPadOrMobileView ? "button-small" : "button-large"}`}
              onClick={() => {
                this.setState({ fold: false });
              }}
            >
              {i18n.t('readMore')}
            </span>
          </>
        ) : null}
      </Container>
    );
  }
}

export default Instruction;
